module.exports = __webpack_public_path__ + "assets/media/morning.3cbde68a.mp3";